import { HoursOverTime } from '@pwp-common';

import { createValueCell } from '../create-event-hours-row';
import { CreateAggregateRowInput, EventHoursRow } from '../interfaces';

export const createAggregateRow = (params: CreateAggregateRowInput): EventHoursRow => {
  const { id, displayName, rows, months } = params;

  let totalHours = 0;
  let totalEvents = 0;

  for (const row of rows) {
    totalHours += row.totalHours ?? 0;
    totalEvents += row.totalEvents ?? 0;
  }

  const result = {
    id,
    displayName: createValueCell(displayName),
    isAdmin: createValueCell(''),
    orgNote: createValueCell(''),
    totalHours,
    totalEvents,
  };

  for (const monthStr of months) {
    const hoursKey = HoursOverTime.getKeyName(HoursOverTime.NUM_HOURS_POSTFIX, monthStr);
    const eventsKey = HoursOverTime.getKeyName(HoursOverTime.NUM_EVENTS_POSTFIX, monthStr);

    result[hoursKey] = rows.reduce((sum, row) => sum + (row?.[hoursKey] ?? 0), 0);
    result[eventsKey] = rows.reduce((sum, row) => sum + (row?.[eventsKey] ?? 0), 0);
  }

  return result as EventHoursRow;
};
